module.exports = __webpack_public_path__ + "static/media/new-numpy.68641c6c.svg";